'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _reportImages = require('./reportImages.component');

var _reportImages2 = _interopRequireDefault(_reportImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportImagesModule = _angular2.default.module('reportImages', [_angularUiRouter2.default]).component('reportImages', _reportImages2.default).name;

exports.default = reportImagesModule;


// WEBPACK FOOTER //
// ./client/app/common/reportImages/reportImages.js